import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class WaWarehouseService extends ApiService {

    select() {
        return super.get(`/wa-warehouses/select`);
    }

    index(params: any): Observable<any> {
        return super.get('/wa-warehouses', params);
    }

    show(id: number): Observable<any> {
        return super.get(`/wa-warehouses/${id}`);
    }

    update(id: number, body: any): Observable<any> {
        return super.put(`/wa-warehouses/${id}`, body);
    }
}
